<template>
    <div class="accomm-container">
        <TitlePart text="Nearby Hotel Information"/>
        <p class="left-aligned-text" style="text-align:justify;">Participants should make their own bookings with the hotels. The organiser takes no responsibility for any commitment the participants made with the hotels.</p>
        <div class="table-responsive">
            <table class="table table-striped table-bordered custom-table">
                <tbody>
                    <tr>
                        <th>Hotel</th>
                        <th>Hotel Rating</th>
                        <th class="longline">Room Type &amp; Room Rate</th>
                        <th>Walking Distance to PolyU</th>
                        <!-- <th>Reservation</th> -->
                    </tr>
                    <tr>
                        <td>
                            <!-- <a style="color: blue;" href="https://www.hotel-icon.com/" target="_blank">Hotel ICON</a> -->
                            <a>Hotel ICON</a>
                        </td>
                        <td>★★★★★</td>
                        <td class="longline">
                            ICON City View King/ ICON City View Twin<br>
                            (Size: 36 sqm)<br><br>
                            HK$1,900 - HK$2,200 + 10% service charge per room per night
                        </td>
                        <td>~ 5 minutes</td>
                        <!-- <td><a href="https://be.synxis.com/?adult=1&arrive=2024-12-08&chain=12116&child=0&currency=HKD&depart=2024-12-10&hotel=51197&level=hotel&locale=en-US&rooms=1&utm_campaign=book-direct&utm_medium=popup&utm_source=direct" style="background-color: yellow;color: blue;" target="_blank">
                            Click Here
                            </a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>
                            <!-- <a style="color: blue;" href="https://www.newworldmillenniumhotel.com/en/" target="_blank">New World Millennium Hong Kong Hotel</a> -->
                            <a>New World Millennium Hong Kong Hotel</a>
                        </td>
                        <td>★★★★★</td>
                        <td class="longline">
                            City View Rooms/ Deluxe City View rooms<br>
                            (Size: 33-39 sqm)<br><br>
                            HK$1,300 - HK$2,600 + 10% service charge per room per night
                        </td>
                        <td>~ 7 minutes</td>
                        <!-- <td><a href="https://reservations.newworldmillenniumhotel.com/?Start=availresults&adult=1&arrive=2024-12-08&chain=14158&child=0&currency=HKD&depart=2024-12-10&hotel=62247&level=hotel&locale=en-US&promo=Direct&rooms=1" style="background-color: yellow;color: blue;" target="_blank">
                            Click Here
                            </a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>
                            <!-- <a style="color: blue;" href="https://www.ihg.com/intercontinental/hotels/us/en/hong-kong/hkghb/hoteldetail?fromRedirect=true&amp;qSrt=sBR&amp;qIta=99502222&amp;icdv=99502222&amp;qDest=70%20Mody%20Rd,%20Tsim%20Sha%20Tsui%20East,%20Hong%20Kong&amp;qSlH=hkghb&amp;qRms=1&amp;qAdlt=1&amp;qChld=0&amp;qCiD=21&amp;qCiMy=072023&amp;qCoD=22&amp;qCoMy=072023&amp;qAAR=6CBARC&amp;qRtP=6CBARC&amp;setPMCookies=true&amp;qSHBrC=IC&amp;qpMn=0&amp;srb_u=1" target="_blank">
                            InterContinental Grand Stanford Hong Kong
                            </a> -->
                            <a>
                            InterContinental Grand Stanford Hong Kong
                            </a>
                        </td>
                        <td>★★★★★</td>
                        <td class="longline">
                            Classic room<br>
                            (Size: 27-32 sqm)<br><br>
                            HK$1,360 + HK$136 additional charges + HK$40.80 taxes per room per night
                            Participants could make reservation directly via <a href="https://www.intercontinental.com/redirect?path=rates&brandCode=IC&localeCode=en&regionCode=1&hotelCode=HKGHB&checkInDate=07&checkInMonthYear=112024&checkOutDate=08&checkOutMonthYear=112024&_PMID=99801505&GPC=LSG&cn=no&viewfullsite=true" target="_blank">Reservation Link</a>.<br>
                            The specific room rate is only applied for dates between 7th Dec to 10th Dec.<br>
                            The breakfast is not included in the fixed price, guests can choose to have breakfast upon their arrival in hotel.
                        </td>
                        <td>~ 7 minutes</td>
                        <!-- <td>
                            <a style="background-color: yellow;color: blue;" href="https://www.ihg.com/hotels/us/en/reservation" target="_blank">
                            Click Here
                            </a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>
                            <!-- <a style="color: blue;" href="https://www.harbour-plaza.com/group/en/" target="_blank">
                            Harbour Plaza Metropolis HK
                            </a> -->
                            <a>
                            Harbour Plaza Metropolis HK
                            </a>
                        </td>
                        <td>★★★★</td>
                        <td class="longline">
                            <ul style="padding-left:20px;margin: 0;">
                                <li>Superior Rooms (Size: 25 sqm) at HK$850 + 10% service charges per room per night </li>
                                <li>Deluxe Rooms (Size: 27 sqm) at HK$1,050 + 10% service charges per room per night</li>
                                <li>Superior One-bedroom Suites (Size: 50 sqm) at HK$1,250 + 10% service charges per room per night</li>
                            </ul><br>
                            Participants could make reservation directly via <a href="https://apc01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fbe.synxis.com%2F%3F_ga%3D2.223162457.357439272.1721704477-1933758700.1702432085%26adult%3D1%26arrive%3D2024-12-06%26chain%3D21619%26child%3D0%26currency%3DHKD%26depart%3D2024-12-07%26group%3DACC202412%26hotel%3D76636%26level%3Dhotel%26locale%3Den-US%26rooms%3D1&data=05%7C02%7Czeayon-zhiyang.xiao%40polyu.edu.hk%7Cc699cc993b994d90cd0c08dcad2e79c4%7C8f37f760b1874981b82fe5dc6f5bcf44%7C0%7C0%7C638575662336783654%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=bJP9tCWdiI3ygMn47vLk7LqM4JLiX3%2B2nlQVa%2FCfzi0%3D&reserved=0" target="_blank">Reservation Link</a>.<br>
                            Please note that it is valid until 15th November 2024.
                        </td>
                        <td>~ 10 minutes</td>
                        <!-- <td>
                            <a style="background-color: yellow;color: blue;" href="https://be.synxis.com/?_ga=2.215020372.259975018.1684896482-423038857.1682397784&amp;_gac=1.171582740.1683623196.EAIaIQobChMIpPeSk_Hn_gIVBqCWCh2avQPLEAAYASAAEgJu5_D_BwE&amp;adult=1&amp;arrive=2023-08-19&amp;chain=21619&amp;child=0&amp;currency=HKD&amp;depart=2023-08-23&amp;group=GSC2023&amp;hotel=76636&amp;level=hotel&amp;locale=en-US&amp;rooms=1" target="_blank">
                            Click Here</a>
                        </td> -->
                    </tr>
                    <tr>
                        <td>
                            <!-- <a style="color: blue;" href="https://www.regalhotel.com/mobile/regal-kowloon-hotel/en/home/home.html" target="_blank">
                            Regal Kowloon Hotel 
                            </a> -->
                            <a>
                            Regal Kowloon Hotel 
                            </a>
                        </td>
                        <td>★★★★</td>
                        <td class="longline">Superior room/ Deluxe room<br>
                            (Size: 27-29 sqm)<br><br>
                            HK$1,500 - HK$1,900 + 10% service charge per room per night
                        </td>
                        <td>~ 7 minutes</td>
                        <!-- <td><a style="background-color: yellow;color: blue;" href="https://www.regalhotel.com/regal-kowloon-hotel/en/accommodations/rooms.html" target="_blank">
                            Click Here</a></td> -->
                    </tr>
                    <tr>
                        <td>
                            <!-- <a style="color: blue;" href="http://www.kimberley.hk/eng/home/" target="_blank">
                            The Kimberley Hotel</a> -->
                            <a>
                                The Kimberley Hotel
                            </a>
                        </td>
                        <td>★★★★</td>
                        <td class="longline">Superior City View Double/ Twin Room<br>
                            (Size: 20 sqm)<br><br>
                            HK$800 - HK$1,200 per room per night
                        </td>
                        <td>~ 10 minutes</td>
                        <!-- <td><a style="background-color: yellow;color: blue;" href="http://www.kimberley.hk/eng/room/" target="_blank">
                            Click Here</a></td> -->
                    </tr>
                    <tr>
                        <td>
                            <!-- <a style="color: blue;" href="http://www.bestwesternplushotelkowloon.com/en/index.html" target="_blank">
                            Best Western Plus Hotel Kowloon
                            </a> -->
                            <a>
                            Best Western Plus Hotel Kowloon
                            </a>
                        </td>
                        <td>★★★</td>
                        <td class="longline">Superior Room<br>
                            (Size: 15 sqm)<br><br>
                            HK$700 - HK$900 per room per night</td>
                        <td>~ 10 minutes</td>
                        <!-- <td><a style="background-color: yellow;color: blue;" href="https://www.agoda.com/zh-hk/best-western-plus-hotel-kowloon/hotel/hong-kong-hk.html?finalPriceView=1&amp;isShowMobileAppPrice=false&amp;cid=1587468&amp;numberOfBedrooms=&amp;familyMode=false&amp;adults=2&amp;children=0&amp;rooms=1&amp;maxRooms=0&amp;checkIn=2023-05-8&amp;isCalendarCallout=false&amp;childAges=&amp;numberOfGuest=0&amp;missingChildAges=false&amp;travellerType=-1&amp;showReviewSubmissionEntry=false&amp;currencyCode=HKD&amp;isFreeOccSearch=false&amp;tag=hid5558,pid0c264f22-11b4-4c63-860c-16a7fb6316bc&amp;isCityHaveAsq=false&amp;los=4&amp;searchrequestid=5b3fd938-aa78-4b39-b57a-de7964c778e0" target="_blank">
                            Click Here</a></td> -->
                    </tr>
                </tbody>
            </table>
        </div>
        <p class="left-aligned-text" style="text-align:justify;">
            * Room rates and availability are subject to change and additional service charge.
        </p>
        <TitlePart text="More Hotel Options"/>
        <p class="left-aligned-text" style="text-align:justify;">You may visit the website of <a href="https://www.discoverhongkong.com/eng/plan/accommodation.html" target="_blank">Hong Kong Tourism Board</a> for more hotel options:<br>
            Area(s): Kowloon; Location(s): Hung Hom, Tsim Sha Tsui East, Tsim Sha Tsui, Jordan
        </p>
        <TitlePart text="Location of Listed Hotels"/>
        <a href="https://www.google.com/maps/place/Tsim+Sha+Tsui+East/@22.2989545,114.1756032,17z/" target="_blank">
            <img src="@/assets/ListedHotels.jpg" class="listedhotels" alt style="width: 100%; margin-top: 10px;">
        </a>
        
        </div>
        <br>
        <br>
        <br>
</template>

<script>
import TitlePart from '@/components/TitlePart/TitlePart.vue'
    export default {
        components:{
            TitlePart
        }
    }
</script>


<style lang="less" scoped>
    @import "./style.less" ;
</style>